export const TYPE = 'type';

export const NAME = 'name';
export const OWNER = 'owner';

export const APPLICATIONS = 'applications';
export const NETWORKS = 'networks';
export const PLATFORMS = 'platforms';
export const ATTACH_FILE = 'fileName';

export const DEPENDENCIES = {
  [APPLICATIONS]: [NETWORKS, PLATFORMS],
  [PLATFORMS]: [NETWORKS],
};

export const PARTNER_AUDIENCES = 'partnerAudiences';

export const getAudienceFromValues = (values) => {
  /* eslint-disable-next-line */
  const { [PARTNER_AUDIENCES]: _, ...audience } = values;
  return audience;
};

export const getPartnerAudiencesFromValues = (values) => {
  return values?.[PARTNER_AUDIENCES] || [];
};
